module.exports = __webpack_public_path__ + "static/media/cp04.2e0f2805.png";